module.exports = __webpack_public_path__ + "img/55.9.TU.0fb2407b.png";